import { Button } from '@fullscreendigital/carrefour-dex-fe'
import { Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import { useNotification } from 'hooks'
import { makeCorePatchRequest } from 'utils/api'
import { formatErrorMessage } from 'utils/formatting'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import { getLocation } from 'components/location/api'

interface DeleteLocationModalProps {
  isModalOpen: boolean
  closeModal: Function
  id: number
  setShouldRefreshData: Function
}

const DeleteLocationModal = (props: DeleteLocationModalProps) => {
  const { isModalOpen, closeModal, id, setShouldRefreshData } = props

  const { showNotification } = useNotification()

  const disableLocation = async () => {
    try {
      await makeCorePatchRequest(
        `/location-management/location-usage/${id}/false`
      )

      closeModal()

      setShouldRefreshData(true)
    } catch (error) {
      showNotification({
        message: `Error while changing location status. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  return (
    <Modal
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      modalTitle="Delete location"
    >
      <Grid container spacing={4}>
        <Grid xs={12} item>
          Are you sure you want to delete this location? This action cannot be undone.
        </Grid>

        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="outlined" label="No" onClick={() => closeModal()} />
          <Button variant="contained" label="Yes" onClick={disableLocation} />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default DeleteLocationModal
